<template>
	<a-dropdown :trigger="[context ? 'contextmenu' : 'hover']">
		<div class="card overflow-hidden">
			<div class="card-header position-relative p-0 image-square">
				<router-link
					:target="target"
					:to="{ name: 'couponEdit', params: { id: data.id } }"
					:class="$style.image"
					:data-status="status"
					class="height-250 pointer"
				>
					<div
						class="align-items-center d-flex font-size-80 font-weight-bolder h-100 justify-content-center w-100"
						style="font-size: 8.33rem;"
					>
						<span v-if="discountValue" class="font-size-40 position-absolute" style="color:#fff;">{{ discountValue }}</span>
						<fa-icon :icon="['fas', 'ticket']" />
					</div>
				</router-link>

				<div :class="$style.actions">
					<slot name="actions" :data="data">
						<a-tooltip v-if="data.offer_url" placement="left">
							<template #title>
								<span>Ir al cupón</span>
							</template>
							<a-button
								shape="circle"
								size="large"
								@click="goTo"
							>
								<a-icon type="link" />
							</a-button>
						</a-tooltip>
					</slot>
				</div>
			</div>

			<div class="card-body p-3">
				<user-avatar
					v-if="author"
					:user="author"
					:size="40"
					:class="[$style.avatar]"
				/>

				<div class="d-flex flex-row align-items-center mb-2">
					<div
						class="font-size-24 font-weight-bold text-dark mr-auto"
					>
						<span v-if="discountValue">{{ discountValue }}</span>
						<span v-else>&nbsp;</span>
					</div>
				</div>
				<div :class="$style.description">
					<router-link
						:target="target"
						:to="{ name: 'couponEdit', params: { id: data.id } }"
					>
						{{ data.name }}
					</router-link>
				</div>
			</div>

			<div
				v-if="data.created_at || data.store"
				class="card-footer d-flex flex-row py-1 px-3 align-items-center"
			>
				<a-tooltip v-if="data.created_at" placement="top">
					<template #title>
						<span>
							{{ $moment(data.created_at).format('LLL') }}
						</span>
					</template>
					<b
						v-if="$moment().diff(data.created_at) > 0"
						class="text-uppercase text-muted mr-auto"
					>{{ $moment(data.created_at).fromNow() }}</b>
					<b v-else class="text-uppercase text-danger mr-auto"><fa-icon
						:icon="['far', 'alarm-clock']"
						class="mr-2 animated pulse delay-1s infinite"
					/>{{ $moment(data.created_at).fromNow() }}</b>
				</a-tooltip>

				<div :class="[$style.store]">
					<template v-if="data.store">
						<img
							v-if="data.store[0].image_url"
							:src="data.store[0].image_url"
							:alt="data.store[0].name"
						>
						<span v-else>
							{{ data.store[0].name }}
						</span>
					</template>
				</div>
			</div>
		</div>

		<template #overlay>
			<a-menu v-if="context" @click="setStatus">
				<a-menu-item key="none" class="bg-white p-2">
					<div class="d-flex flex-row overflow-hidden">
						<a-avatar
							:src="images().deal(data, 100)"
							:size="40"
							shape="square"
							class="mr-2"
						/>
						<div
							class="overflow-hidden d-flex flex-column"
							:style="{ 'max-width': '360px' }"
						>
							<b class="text-truncate">{{ data.name }}</b>
							#{{ data.id }}
						</div>
					</div>
				</a-menu-item>

				<a-menu-divider />
				<a-menu-item key="active" class="text-success">
					<a-icon type="eye" /> Activo
				</a-menu-item>
				<a-menu-item key="expired" class="text-danger">
					<a-icon type="eye-invisible" /> Agotado
				</a-menu-item>
				<a-menu-item key="pending" class="text-primary">
					<a-icon type="alert" /> En revisión...
				</a-menu-item>
				<a-menu-item key="draft" class="text-warning">
					<a-icon type="file" /> Borrador
				</a-menu-item>
				<a-menu-divider />
				<a-menu-item key="disabled">
					<a-icon type="delete" /> Eliminar
				</a-menu-item>
			</a-menu>
		</template>
	</a-dropdown>
</template>
<script>
/* eslint-disable vue/no-mutating-props */
// import _ from 'lodash';

export default {
	name: 'CouponCard',
	props: {
		data: {
			type: Object,
			required: true,
		},
		user: {
			type: [Object, Boolean],
			default: null,
		},
		target: {
			type: String,
			default: '_self',
		},
		context: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		author() {
			if (this.user) {
				return this.user;
			}
			if (this.data.user) {
				return this.data.user;
			}

			return null;
		},
		discountValue() {
			if (['%', '€'].some(d => d === this.data.discount_type)) {
				return this.data.discount_value + this.data.discount_type;
			}


			if (this.data.discount_type === 'free_shipping') {
				return 'Envío gratis';
			}

			return '';

			// if (this.data.discount_value) {
			// 	return [this.data.discount_value, this.data.discount_type];
			// }

			// if (this.data.sale_price === 0) {
			// 	return ['GRATIS', ''];
			// }

			// return ['...', ''];
		},
		status() {
			const locked = this.$store.getters['socket/lockedPost'](
				this.data.id,
			);

			if (locked.status) return 'locked';
			return this.data.status;
		},
	},
	methods: {
		async setStatus(e) {
			if (e.key === 'none') {
				this.$router.push({
					name: 'post',
					params: { id: this.data.id },
				});
			} else {
				const status = e.key;
				const edit = await this.$sdk
					.deals()
					.edit(this.data.id, { status });

				if (edit.ok) {
					// await this.$root.wordpress().status(this.data, status);

					this.data.status = status;

					this.$store.dispatch('setItem', {
						id: this.data.id,
						data: this.data,
						type: 'posts',
					});
					this.$store.dispatch('setItem', {
						id: this.data.id,
						data: this.data,
						type: 'pendingPosts',
					});

					this.$message.success(
						'Se modifico el estado del post correctamente',
					);
				}
			}
		},
		goTo() {
			window.open(this.data.offer_url, '_blank');
		},
	},
};
</script>
<style lang="scss" module>
@import './style.module.scss';

.image {
	position: relative;
	overflow: hidden;
}

.image img {
	position: absolute;
	top: 0;
}
</style>
